module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Help","heading":"Help","table_contents":"Table of Contents"},"ja":{"browser_title":"ヘルプ","heading":"ヘルプ","table_contents":"目次"}}')
  delete Component.options._Ctor
}
